<script setup lang="ts">
import { vOnClickOutside } from '@vueuse/components'
import type { ClientHit } from '../models/search.model'

import PanelDivider from '@/shared/components/divider/PanelDivider.vue'
import SearchResultTable from './SearchResultTable.vue'
import SearchRecentList from './SearchRecentList.vue'
import TabClient from './ClientTab.vue'
import FadeTransition from '@/shared/components/transitions/FadeTransition.vue'

interface Props {
  loading: boolean
  active: boolean
  hits: ClientHit[]
  current: boolean
}

interface Emits {
  (e: 'click'): void
  (e: 'apply'): void
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()

const emits = defineEmits<Emits>()
const model = defineModel<ClientHit>()
const open = defineModel<boolean>('open', { required: true })

const onApply = (): void => {
  emits('apply')
}

const onClick = (): void => {
  emits('click')
}
</script>

<template>
  <FadeTransition>
    <div
      v-if="open"
      class="z-40 absolute bg-white border-x border-b border-gray-300 w-full shadow-md"
      v-on-click-outside="() => (open = false)"
    >
      <SearchRecentList @click="onClick" />
      <div v-if="hits.length > 0" class="flex flex-col gap-2 pt-2">
        <PanelDivider :text="$t('glossary.account', 2)" class="text-gray-700 px-3" />
        <TabClient v-model="model" :clients="hits" @click="onApply" />
        <SearchResultTable v-model="model" :loading="loading" />
      </div>
      <div
        v-if="!loading && model && hits.length === 0"
        class="font-light text-sm text-gray-700 text-center py-2"
      >
        {{ $t('message.noSearchTermMatch') }}
      </div>
    </div>
  </FadeTransition>
</template>
